/**
 * Server error messages are written in English (they are also log lines and
 * test assertions). The UI is Portuguese, so the client translates them on
 * the way in. Unknown messages pass through unchanged.
 */

const EXACT: Record<string, string> = {
  // Trade between players (server trade.ts; reference texts) and starter packs.
  'You cannot trade right now.': 'Você não pode fazer trade agora.',
  'You are too far away to trade.': 'Você está longe demais para fazer trade.',
  'That player is already trading.': 'Esse jogador já está em um trade.',
  'That trade request has expired.': 'Esse pedido de trade expirou.',
  'You are not trading.': 'Você não está em um trade.',
  'That item is already on the table.': 'Esse item já está na mesa.',
  'There is nothing on the table.': 'Não tem nada na mesa.',
  'Confirm unlocks once both of you check your offer.': 'O confirmar libera quando os dois marcarem a oferta.',
  'The offer changed — both checks were cleared.': 'A oferta mudou — as duas marcações foram desfeitas.',
  'You do not carry that much gold.': 'Você não está carregando todo esse gold.',
  'Invalid amount.': 'Quantidade inválida.',
  'Choose your exercise weapon.': 'Escolha sua arma de treino.',
  'A perk of that level is already active. Clear the perks to choose again.': 'Já existe um perk ativo deste nível. Limpe os perks para escolher de novo.',
  'Activate a prey first.': 'Ative uma prey primeiro.',
  'Admin only.': 'Somente administradores.',
  'Already in a guild.': 'Você já está em uma guild.',
  'Already unlocked.': 'Já está desbloqueado.',
  'Backpack is full.': 'A mochila está cheia.',
  'Beta is closed. A valid invite code is required.': 'O beta está fechado. É preciso um código de convite válido.',
  'Cannot transfer to yourself.': 'Você não pode transferir para si mesmo.',
  'That character is on your account: the coins are already shared.': 'Esse personagem é da sua conta: as coins já são as mesmas para todos os seus personagens.',
  'Character slots are already maxed.': 'Os espaços de personagem já estão no máximo.',
  'Choose a vocation first.': 'Escolha uma vocação primeiro.',
  'Clear the previous arena first.': 'Conclua a arena anterior primeiro.',
  'Code already used.': 'Este código já foi usado.',
  'Could not create a guest account.': 'Não foi possível criar uma conta de convidado.',
  'Daily already claimed today.': 'A recompensa diária já foi pega hoje.',
  'Donor needs classification 1+.': 'O item doador precisa de classificação 1 ou mais.',
  'Donor slot is empty.': 'O slot doador está vazio.',
  'Dust limit is already at the maximum.': 'O limite de poeira já está no máximo.',
  'Empty message.': 'Mensagem vazia.',
  'Empty preset.': 'Preset vazio.',
  'Equip something in that slot first.': 'Equipe algo nesse slot primeiro.',
  'Fighter not found.': 'Lutador não encontrado.',
  'Finish or wait for the active prey first.': 'Termine ou espere a prey ativa primeiro.',
  'Finish that bestiary entry first.': 'Complete essa entrada do Bestiary primeiro.',
  'That creature has no bestiary entry.': 'Essa criatura não tem entrada no Bestiary.',
  // Roda do Destino (server wheel-save / wheel-reset).
  'Saved points only leave the wheel with a reset.': 'Pontos salvos só saem da roda com um reset.',
  'Not enough wheel points.': 'Pontos da roda insuficientes.',
  'That slice is not open yet.': 'Essa fatia ainda não está liberada.',
  'Invalid wheel.': 'Roda inválida.',
  'The Wheel of Destiny needs a premium account.': 'A Roda do Destino precisa de conta premium.',
  'The wheel is already empty.': 'A roda já está vazia.',
  'The Wheel of Destiny changed: reload the game and place your points on the new wheel.': 'A Roda do Destino mudou: recarregue o jogo e coloque seus pontos na roda nova.',
  'Finish the active prey first.': 'Termine a prey ativa primeiro.',
  'Finish the hunt before changing gear.': 'Saia da caçada antes de trocar o equipamento.',
  'Finish the hunt first.': 'Saia da caçada primeiro.',
  'Guild name is 3-24 letters.': 'O nome da guild tem de 3 a 24 letras.',
  'Guild not found.': 'Guild não encontrada.',
  'Incorrect username or password.': 'Usuário ou senha incorretos.',
  'You must accept the rules to create an account.': 'Marque que leu e aceita as regras para criar a conta.',
  'Enter a valid e-mail address.': 'Escreva um endereço de e-mail válido (ex.: voce@exemplo.com).',
  'Incorrect e-mail or password.': 'E-mail ou senha incorretos.',
  'Enter your e-mail.': 'O e-mail e a senha são obrigatórios.',
  'That e-mail is already registered.': 'Este e-mail já está cadastrado.',
  'This e-mail provider is not accepted. Use a permanent e-mail address.': 'Este provedor de e-mail não é aceito. Use um endereço de e-mail permanente.',
  'That e-mail is too long.': 'Esse e-mail é longo demais (máximo de 254 caracteres).',
  'Missing "email".': 'O e-mail e a senha são obrigatórios.',
  'Missing "password".': 'O e-mail e a senha são obrigatórios.',
  'Enter your e-mail, username or character name.': 'Digite seu e-mail, a sua conta ou o nome de um personagem.',
  'This reset link is invalid or has expired.': 'Este link é inválido ou já expirou. Peça um novo.',
  'Guest play is no longer available. Create an account.': 'O modo convidado não existe mais. Crie uma conta.',
  'Invalid action bar.': 'Barra de ações inválida.',
  // Action bar sets (server actionBarPresets.ts; reference texts).
  'Name the set.': 'Dê um nome ao conjunto.',
  'Set names are 1-24 characters.': 'O nome do conjunto tem de 1 a 24 caracteres.',
  'Unknown action bar set.': 'Conjunto desconhecido.',
  'The Default set cannot be deleted.': 'O conjunto Default não pode ser excluído.',
  'Invalid addon.': 'Addon inválido.',
  'Invalid addons.': 'Addons inválidos.',
  'Invalid aura.': 'Aura inválida.',
  'Invalid code.': 'Código inválido.',
  'Invalid cosmetic id.': 'Cosmético inválido.',
  'Invalid count.': 'Quantidade inválida.',
  'Invalid invite.': 'Convite inválido.',
  'Invalid item.': 'Item inválido.',
  'Invalid level.': 'Level inválido.',
  'Invalid loot filter.': 'Filtro de loot inválido.',
  'Invalid nickname.': 'Apelido inválido.',
  'Invalid outfit.': 'Outfit inválido.',
  'Invalid preset slot.': 'Preset inválido.',
  'Invalid prey slot.': 'Slot de prey inválido.',
  'Invalid price.': 'Preço inválido.',
  'Invalid selection.': 'Seleção inválida.',
  'Invalid step.': 'Passo inválido.',
  'Leave your guild first.': 'Saia da sua guild primeiro.',
  'Listing gone.': 'Esse anúncio não existe mais.',
  'Loot pouch is already maxed.': 'A bolsa de loot já está no máximo.',
  'Mount not unlocked.': 'Montaria não desbloqueada.',
  'Names are 3-20 characters and start with a letter.': 'O nome tem de 3 a 20 letras e começa com uma letra.',
  'No active imbuement on that piece.': 'Essa peça não tem imbuement ativo.',
  'No character with that name.': 'Nenhum personagem com esse nome.',
  'No such character.': 'Personagem não encontrado.',
  'No vocation can sustain that hunt yet.': 'Nenhuma vocação aguenta essa caçada ainda.',
  'No wheel points left.': 'Sem pontos da roda sobrando.',
  'Nobody buys that item.': 'Ninguém compra esse item.',
  'Normal transfer needs donor classification 2+ (result is tier - 1).': 'A transferência normal pede classificação 2+ no doador (o resultado é tier − 1).',
  'Not enough charm points.': 'Charm points insuficientes.',
  'Not enough coins.': 'Coins insuficientes.',
  'Not enough gold.': 'Gold insuficiente.',
  'Nothing equipped in that slot.': 'Nada equipado nesse slot.',
  'Only a Rookie picks a starting weapon.': 'Só um Rookie escolhe a arma inicial.',
  'Only the leader can kick.': 'Só o líder pode expulsar.',
  'Order is not pending.': 'O pedido não está pendente.',
  'Outfit does not match character gender.': 'Esse outfit não é do sexo do personagem.',
  'Outfit not unlocked.': 'Outfit não desbloqueado.',
  'Party is full.': 'A party está cheia.',
  'That channel is full.': 'Esse canal está cheio.',
  'You cannot invite yourself.': 'Você não pode convidar a si mesmo.',
  'That player is not online.': 'Esse jogador não está online.',
  'That player is already in a party.': 'Esse jogador já está em uma party.',
  'Only the party leader can invite.': 'Só o líder da party pode convidar.',
  'That party no longer exists.': 'Essa party não existe mais.',
  'That invitation has expired.': 'Esse convite expirou.',
  'You are already in a party.': 'Você já está em uma party.',
  'Only the party leader can do that.': 'Só o líder da party pode fazer isso.',
  'That player is not in your party.': 'Esse jogador não está na sua party.',
  // Party remake (server partyProposals.ts; reference texts where it has them).
  'You are not in a party.': 'Você não está em uma party.',
  'Only the party leader can start a hunt.': 'Apenas o líder do time pode iniciar uma caçada.',
  'Only the party leader can change the hunt.': 'Só o líder da party pode trocar de caçada.',
  'The leader cannot be removed — leave the party instead.': 'O líder não pode ser expulso — saia da party.',
  'A kick vote is already running.': 'Já existe uma votação de expulsão em andamento.',
  'The leadership cannot be passed during a boss or quest run.': 'A liderança não pode ser passada durante uma run de boss ou quest.',
  "You can no longer join the leader's hunt.": 'Você não pode mais entrar na caçada do líder.',
  'The party leader has no proposals to accept.': 'O líder da party não tem propostas para aceitar.',
  'The party already shares hunt costs.': 'A party já rateia os custos da hunt.',
  'A shared-costs proposal is already waiting.': 'Já existe uma proposta de rateio esperando resposta.',
  'That proposal is no longer open.': 'Essa proposta não está mais aberta.',
  'The party does not share hunt costs.': 'A party não está rateando os custos.',
  'That vote is over.': 'Essa votação já terminou.',
  'You cannot vote on your own removal.': 'Você não pode votar na sua própria expulsão.',
  'Nobody else in your party is online.': 'Ninguém mais da sua party está online.',
  'No character by that name.': 'Nenhum personagem com esse nome.',
  'Password must be at least 8 characters.': 'A senha precisa ter pelo menos 8 caracteres.',
  'Pick a member to kick.': 'Escolha um membro para expulsar.',
  'Pick another fighter.': 'Escolha outro lutador.',
  'Pick one of the five vocations.': 'Escolha uma das cinco vocações.',
  'Pick one of the training weapons.': 'Escolha uma das armas de treino.',
  'Pick two different slots.': 'Escolha dois slots diferentes.',
  "Pick your prize at the winner's table first.": 'Escolha o seu prêmio na Mesa do vencedor primeiro.',
  'Proficiency level too low for that perk.': 'Nível de proficiência baixo demais para esse perk.',
  'Reach Base stage on this boss first.': 'Chegue ao estágio Base nesse boss primeiro.',
  'Receiver must be classification 0.': 'O item que recebe precisa ter classificação 0.',
  'Receiver slot is empty.': 'O slot que recebe está vazio.',
  'Send at least 1 coin.': 'Envie pelo menos 1 coin.',
  'Sign in first.': 'Entre na sua conta primeiro.',
  'Supply pouch is already maxed.': 'A bolsa de suprimentos já está no máximo.',
  'Supply pouch is full.': 'A bolsa de suprimentos está cheia.',
  'That boss has no Bosstiary entry.': 'Esse boss não tem entrada no Bosstiary.',
  'That character is already hunting.': 'Esse personagem já está caçando aqui.',
  'That character is not hunting.': 'Esse personagem não está caçando.',
  'That creature is already fully influenced.': 'Essa criatura já está com influência máxima.',
  'That creature is already selected in another prey slot.': 'Essa criatura já está em outro slot de prey.',
  'That creature is not available as prey.': 'Essa criatura não está disponível como prey.',
  'That creature is not on your prey list.': 'Essa criatura não está na sua lista de prey.',
  'That guild exists.': 'Essa guild já existe.',
  'That hunter is not in your guild.': 'Esse jogador não está na sua guild.',
  'That imbuement does not fit.': 'Esse imbuement não serve nessa peça.',
  'That imbuement slot is empty.': 'Esse slot de imbuement está vazio.',
  'That is not a boss.': 'Isso não é um boss.',
  'That is not a weapon.': 'Isso não é uma arma.',
  'That is your own listing.': 'Esse anúncio é seu.',
  // Auction house / Valiosos (server market.ts)
  'Offer gone.': 'Essa oferta não existe mais.',
  'The auction house only trades in the city — head back to town to confirm.': 'A casa de leilões só negocia na cidade — volte para a cidade para confirmar.',
  // RMT (server rmt.ts) — reference texts.
  'Only premium accounts can sell on RMT.': 'Só contas premium vendem no RMT.',
  'RMT only trades in the city — head back to town to confirm.': 'O RMT só negocia na cidade — volte pra cidade para confirmar.',
  "That payment lane isn't open right now.": 'Essa forma de pagamento não está aberta agora.',
  'Name a price in at least one currency.': 'Ponha um preço em pelo menos uma moeda.',
  "That price is out of RMT's bounds.": 'Esse preço está fora dos limites do RMT.',
  "That offer is out of RMT's bounds.": 'Essa oferta está fora dos limites do RMT.',
  'Name how much gold you are selling.': 'Diga quanto gold você está vendendo.',
  "You don't carry that much gold.": 'Você não está carregando todo esse gold.',
  'That item cannot be sold on RMT.': 'Esse item não pode ser vendido no RMT.',
  'RMT is not trading forged items yet. Try again shortly.': 'O RMT ainda não está negociando itens forjados. Tente de novo em instantes.',
  'That offer is gone. Nothing was charged.': 'Essa oferta não existe mais. Nada foi cobrado.',
  'That offer is gone.': 'Essa oferta não existe mais.',
  'That offer has expired.': 'Essa oferta expirou.',
  "You can't buy your own offer.": 'Você não pode comprar a sua própria oferta.',
  'That offer is no longer yours to cancel.': 'Essa oferta não é mais sua para cancelar.',
  'You do not have that many.': 'Você não tem essa quantidade.',
  'Only premium accounts post coin offers.': 'Só contas premium podem anunciar Tibia Coins no mercado.',
  'A standing buy order already pays that much or more — sell into it first.': 'Uma ordem de compra em aberto já paga isso ou mais — venda para ela primeiro.',
  'A standing sell offer already asks that little or less — buy from it first.': 'Uma oferta de venda em aberto já pede isso ou menos — compre dela primeiro.',
  'That item cannot be equipped.': 'Esse item não pode ser equipado.',
  'That item has no imbuement slots.': 'Esse item não tem slots de imbuement.',
  'That item is not in the pouch.': 'Esse item não está na bolsa.',
  "That item is not on the winner's table.": 'Esse item não está na Mesa do vencedor.',
  'That loot is no longer there.': 'Esse loot não está mais lá.',
  'That name is taken.': 'Esse nome já está em uso.',
  'That node is maxed.': 'Esse nó já está no máximo.',
  'That perk is already active.': 'Esse perk já está ativo.',
  'That piece is already classification 10.': 'Essa peça já está na classificação 10.',
  'That prey slot is already active.': 'Esse slot de prey já está ativo.',
  'That slot does not hold the item.': 'Esse slot não tem esse item.',
  'That slot is empty.': 'Esse slot está vazio.',
  'That spell is not yours to cast.': 'Essa magia não é da sua vocação.',
  'That username is taken.': 'Esse usuário já existe.',
  'The merchant does not sell that.': 'O mercador não vende isso.',
  'The starting weapon was already chosen.': 'A arma inicial já foi escolhida.',
  'The vocation was already chosen.': 'A vocação já foi escolhida.',
  'There is no prize waiting.': 'Não há prêmio esperando.',
  'This account is already claimed.': 'Esta conta já foi reivindicada.',
  "This arena's prize was already taken.": 'O prêmio desta arena já foi pego.',
  'This boss is on cooldown. You can fight again 20 hours after a kill.': 'Esse boss está em espera. Você pode lutar de novo 20 horas depois de matar.',
  'Tier is 1, 2 or 3.': 'O tier é 1, 2 ou 3.',
  'Unknown action.': 'Ação desconhecida.',
  'Unknown arena.': 'Arena desconhecida.',
  'Unknown boss.': 'Boss desconhecido.',
  'Unknown channel.': 'Canal desconhecido.',
  'Unknown charm.': 'Charm desconhecido.',
  'Unknown code.': 'Código desconhecido.',
  'Unknown coin pack.': 'Pacote de coins desconhecido.',
  'Unknown creature.': 'Criatura desconhecida.',
  'Unknown decoration.': 'Decoração desconhecida.',
  'Unknown item source.': 'Origem do item desconhecida.',
  'Unknown item.': 'Item desconhecido.',
  'Unknown perk.': 'Perk desconhecido.',
  'Unknown pull size.': 'Tamanho de pull desconhecido.',
  'Unknown shop item.': 'Item da loja desconhecido.',
  'Unknown starting weapon.': 'Arma inicial desconhecida.',
  'Unknown wheel node.': 'Nó da roda desconhecido.',
  'Unlock a Bosstiary stage first.': 'Libere um estágio do Bosstiary primeiro.',
  'Unlock that charm first.': 'Desbloqueie esse charm primeiro.',
  'Username must be 3-20 characters: letters, numbers, hyphen or underscore.': 'O usuário tem de 3 a 20 caracteres: letras, números, hífen ou sublinhado.',
  'You already carry every blessing.': 'Você já tem todas as bênçãos.',
  'You already have that blessing.': 'Você já tem essa bênção.',
  'You already own this mount.': 'Você já tem essa montaria.',
  'You already own this outfit.': 'Você já tem esse outfit.',
  'You are already in the arena.': 'Você já está na arena.',
  'You are already promoted.': 'Você já foi promovido.',
  'You are not hunting.': 'Você não está caçando.',
  'You are not in a guild.': 'Você não está em uma guild.',
  'You do not have that item.': 'Você não tem esse item.',
  'You do not have the capacity to carry this item.': 'Você não tem capacidade para carregar este item.',
  'Your backpack is full.': 'Sua mochila está cheia.',
  'Your vocation or level cannot wear that.': 'Sua vocação ou level não pode usar isso.',
};

const PATTERNS: Array<[RegExp, (...groups: string[]) => string]> = [
  [/^You asked (.+) to trade\.$/, (name) => `Você chamou ${name} para um trade.`],
  [/^(.+) could not join from outside the city\. The team hunt was cancelled\.$/, (name) => `${name} não conseguiu entrar de fora da cidade. A caçada em grupo foi cancelada.`],
  [/^(.+) is out of stamina\. The team hunt was cancelled\.$/, (name) => `${name} está sem stamina. A hunt em equipe foi cancelada.`],
  [/^(.+) cannot carry that much — both checks were cleared\.$/, (name) => `${name} não consegue carregar tudo isso — as duas marcações foram desfeitas.`],
  [/^(.+) cannot hand that over today — both checks were cleared\.$/, (name) => `${name} não pode entregar isso hoje — as duas marcações foram desfeitas.`],
  [/^You cannot put more than (\d+) items on the table\.$/, (n) => `Você não pode colocar mais de ${n} itens na mesa.`],
  [/^You have already traded an item today\. Free accounts hand over (\d+) item a day — it resets at midnight\.$/, (n) => `Você já negociou um item hoje. Contas free entregam ${n} item por dia — reinicia à meia-noite.`],
  [/^Free accounts put (\d+) item on the table at a time\.$/, (n) => `Contas free colocam ${n} item na mesa por vez.`],
  [/^Free accounts hand over at most (\d+) of a stackable item — split the stack first\.$/, (n) => `Contas free entregam no máximo ${n} unidades de um item empilhável — divida a pilha antes.`],
  [/^Your (.+) is bound to you and cannot be traded\.$/, (item) => `Seu ${item} é vinculado a você e não pode ser negociado.`],
  [/^You cannot hold more than (\d+) prey wildcards — spend some first\.$/, (n) => `Você não pode guardar mais de ${Number(n).toLocaleString('pt-BR')} prey wildcards — gaste algumas antes.`],
  [/^An account holds at most (\d+) characters\.$/, (n) => `Uma conta tem no máximo ${n} personagens.`],
  [/^Need ([\d.,]+) gold for a list reroll\.$/, (n) => `Precisa de ${n} gold para trocar a lista.`],
  [/^Need ([\d.,]+) gold to skip\.$/, (n) => `Precisa de ${n} gold para pular.`],
  [/^Need ([\d.,]+) gold\.$/, (n) => `Precisa de ${n} gold.`],
  // Reference bestiary unlock (its pt-BR dictionary).
  [/^Stage (\d+) of (.+) still needs ([\d.,]+) kills before it can be unlocked\.$/, (stage, monster, kills) => `A fase ${stage} de ${monster} ainda precisa de ${kills} abates antes de ser desbloqueada.`],
  [/^Need ([\d.,]+) Tibia Coins\.$/, (n) => `Precisa de ${n} Tibia Coins.`],
  [/^Need ([\d.,]+) coins\.$/, (n) => `Precisa de ${n} coins.`],
  [/^Need ([\d.,]+) forge dust\.$/, (n) => `Precisa de ${n} de poeira da forja.`],
  [/^Need ([\d.,]+) forge slivers\.$/, (n) => `Precisa de ${n} slivers da forja.`],
  [/^Need ([\d.,]+) Prey Wildcards?\.$/, (n) => `Precisa de ${n} Prey Wildcard(s).`],
  [/^Need (\d+)\D+(.+) in the warehouse\.$/, (n, name) => `Precisa de ${n}× ${name} no depot.`],
  [/^Need level (\d+) to be promoted\.$/, (n) => `Precisa do level ${n} para ser promovido.`],
  [/^Minimum (\d+) gold\.$/, (n) => `Mínimo de ${n} gold.`],
  [/^You need at least (\d+) minutes of stamina to start a hunt — it refills while you are not hunting\.$/, (n) => `Você precisa de pelo menos ${n} minutos de stamina para iniciar uma caçada — ela recarrega enquanto você não está caçando.`],
  [/^You have refilled your stamina (\d+) times today — the next one is tomorrow\.$/, (n) => `Você já recarregou a stamina ${n} vezes hoje — a próxima é amanhã.`],
  [/^Your stamina is already full\.$/, () => 'Sua stamina já está cheia.'],
  [/^Reach level (\d+) to choose a vocation\.$/, (n) => `Chegue ao level ${n} para escolher a vocação.`],
  [/^Wheel unlocks at level (\d+)\.$/, (n) => `A roda libera no level ${n}.`],
  [/^That hunt needs a party of (\d+)\. Unlock more party slots first\.$/, (n) => `Essa caçada precisa de uma party de ${n}. Libere mais slots de party primeiro.`],
  [/^That hunt needs about level (\d+)\. You are level (\d+)\.$/, (need, have) => `Essa caçada pede por volta do level ${need}. Você está no level ${have}.`],
  [/^This boss needs about level (\d+)\. You are level (\d+)\.$/, (need, have) => `Esse boss pede por volta do level ${need}. Você está no level ${have}.`],
  [/^The (.+) needs level (\d+)\.$/, (name, n) => `A ${name} pede level ${n}.`],
  [/^Unknown shrine item: (.+)\.$/, (name) => `Item do santuário desconhecido: ${name}.`],
  // Reference chat-policy texts (server: chatPolicy.ts).
  [/^You need level (\d+) to talk in this channel\.$/, (n) => `Você precisa do level ${n} para falar neste canal.`],
  [/^Wait (\d+)s to talk in the global chat again\.$/, (n) => `Espere ${n}s para falar no chat global de novo.`],
  [/^Wait (\d+)s to talk in this channel again\.$/, (n) => `Espere ${n}s para falar neste canal de novo.`],
  [/^You have been muted for (\d+) seconds for flooding the chat\.$/, (n) => `Você foi silenciado por ${n} segundos por inundar o chat.`],
  [/^You are muted for flooding the chat\. Wait (\d+)s\.$/, (n) => `Você está silenciado por inundar o chat. Espere ${n}s.`],
  [/^Muted until ([^:]+): (.*)$/,(until, reason) => `Silenciado até ${new Date(until).toLocaleString('pt-BR')}: ${reason}`],
  [/^Free accounts place (\d+) offers a day — the allowance resets at midnight\.$/, (n) => `Contas free anunciam ${n} ofertas por dia — a cota reinicia à meia-noite.`],
  [/^Free accounts list at most (\d+) of an item in one offer\.$/, (n) => `Contas free anunciam no máximo ${n} unidades de um item por oferta.`],
  [/^You are listing too fast\. Try again in (\d+)s\.$/, (n) => `Você está anunciando rápido demais. Tente de novo em ${n}s.`],
  [/^You need (\d+) more coins\.$/, (n) => `Faltam ${n} coins.`],
  [/^You already have (\d+) active offers\.$/, (n) => `Você já tem ${n} ofertas ativas.`],
  [/^The (\d+) gold listing fee is more than you carry\.$/, (n) => `A taxa de ${n} de gold para anunciar é mais do que você carrega.`],
  [/^That offer needs (\d+) gold \(price plus the (\d+) fee\)\.$/, (total, fee) => `Essa oferta precisa de ${total} de gold (preço mais a taxa de ${fee}).`],
  [/^You need (\d+) silver tokens\.$/, (n) => `Você precisa de ${n} silver tokens.`],
  [/^Missing "(.+)"\.$/, (field) => `Falta o campo "${field}".`],
  [/^Level must be 1-2000\.$/, () => 'O level vai de 1 a 2000.'],
  [/^You already have an action bar preset called "(.+)"\.$/, (name) => `Você já tem um conjunto da barra de ações chamado "${name}".`],
  [/^You can keep (\d+) action bar presets\. Delete one before saving another\.$/, (n) => `Você pode guardar ${n} conjuntos da barra de ações. Exclua um antes de salvar outro.`],
];

export function translateError(message: string, locale: string): string {
  if (locale === 'en' || !message) return message;
  const exact = EXACT[message];
  if (exact) return exact;
  for (const [pattern, render] of PATTERNS) {
    const match = message.match(pattern);
    if (match) return render(...match.slice(1));
  }
  return message;
}
